/* eslint-disable react/prop-types */
/* eslint-env browser */
import classnames from 'classnames'
import React from 'react'

import slug from 'slug'
import { insertURLParameter } from '../../../../common/client/url-manipulator'
import { useTranslator } from '../TranslatorProvider'

interface FishingTrailsFullListProps {
  host: string
  hostPath: string
  locale: string
  initialQuery?: string
  description?: string
  fishingTrails: {
    id: string
    name: string
    geometry: {
      type: string
      coordinates: number[][]
    }
    trailType?: string
    place?: {
      locality?: string
      administrativeAreaLevel1?: string
    }
  }[]
}

export const FishingTrailsFullList: React.FC<FishingTrailsFullListProps> = ({
  fishingTrails,
  host,
  hostPath,
  description,
  initialQuery,
  locale,
}) => {
  const t = useTranslator(locale)

  const [searchQuery, setSearchQuery] = React.useState(initialQuery || '')
  const onSearchQueryChange: React.ChangeEventHandler<HTMLInputElement> = React.useCallback(e => {
    setSearchQuery(e.target.value)
    insertURLParameter('q', e.target.value)
  }, [])

  const filteredFishingTrails = React.useMemo(() => {
    if (searchQuery.trim().length === 0) {
      return fishingTrails
    }
    return fishingTrails.filter(elt =>
      `${elt.name}`.toLocaleLowerCase().includes(searchQuery.toLocaleLowerCase().trim())
    )
  }, [searchQuery])

  return (
    <div>
      <div className="columns is-multiline has-padding-horizontal-medium">
        {description && (
          <div className="column is-12">
            <p>{description}</p>
            {/*
            <p>
              <a href="/map">{`${t('hydro.country.searchInput.mapLink')} >`}</a>
            </p>
            */}
          </div>
        )}
        <div className="column is-12">
          <form
            itemProp="potentialAction"
            itemScope
            itemType="http://schema.org/SearchAction"
            action={`${host}${hostPath}`}
            method="GET"
          >
            <div className="field">
              <div className={classnames('control has-icons-left')}>
                <meta itemProp="target" content={`${host}${hostPath}?q={q}`} />
                <input
                  value={searchQuery}
                  onChange={onSearchQueryChange}
                  className="input"
                  type="text"
                  id="q"
                  name="q"
                  placeholder={t('hydro.fishingTrails.searchInput.placeholder')}
                  itemProp="query-input"
                />
                <span className="icon is-medium is-left">
                  <i className={classnames('has-text-primary fas fa-search')} />
                </span>
              </div>
            </div>
          </form>
        </div>
        <div className="column is-12">
          <ul>
            {filteredFishingTrails.map(elt => (
              <li key={elt.id}>
                <a
                  href={`/spots/${slug(elt.name)}-${elt.id}`}
                  title={elt.name}
                  className="is-size-6"
                  style={{ whiteSpace: 'normal' }}
                >
                  <div>
                    <b>{elt.name}</b>
                    {elt.trailType ? (
                      <b className="has-text-grey">
                        {' - '} {t(`hydro.fishingTrails.trailTypes.${elt.trailType}`)}
                      </b>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className="has-margin-bottom-small">
                    {elt.place ? (
                      <span>
                        {[elt.place?.locality, elt.place?.administrativeAreaLevel1]
                          .filter(predicate => !!predicate)
                          .join(', ')}
                      </span>
                    ) : (
                      ''
                    )}
                  </div>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}
